import { render, staticRenderFns } from "./ReceiptRed.vue?vue&type=template&id=b16a2314&scoped=true"
import script from "./ReceiptRed.vue?vue&type=script&lang=js"
export * from "./ReceiptRed.vue?vue&type=script&lang=js"
import style0 from "./ReceiptRed.vue?vue&type=style&index=0&id=b16a2314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16a2314",
  null
  
)

export default component.exports